import type { ShopDto, TextDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import useInvalidateShop from "./use-invalidate-shop";

type UpdatePortalCustomMessageParams = {
  key: string;
  value: TextDto[];
};

export default function useUpdatePortalCustomMessage(shop: ShopDto) {
  const invalidateShop = useInvalidateShop(shop.id);

  return useApiMutation(
    "patch",
    "/shops/{shopId}/preferences/portals",
    {
      invalidate: invalidateShop,
      mapVariables: (requestBody: UpdatePortalCustomMessageParams) => ({
        params: { path: { shopId: shop.id } },
        body: {
          [requestBody.key]: requestBody.value,
        },
      }),
    },
  );
}
